import React from 'react';
import './CloseButton.css';

interface CloseButtonProps {
  onClick: () => void;
  className?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button 
      className={`close-button ${className}`}
      onClick={onClick}
      aria-label="Close"
    >
      ×
    </button>
  );
};

export default CloseButton;
